var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVestaPropertyPattern01TealBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 133,
    viewBox: "0 0 131 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727276",
    d: "M64.8060749,-1.09919406 L64.8192605,-1.11810009 L65.3112271,-0.268729929 L87.0802928,37.3151224 L93.4853335,48.4436178 L129.378325,110.806561 L129.395368,110.838249 L129.731932,111.50966 L64.6853554,130.651525 L64.5088419,130.599532 L63.5867104,130.32791 L-0.097228046,111.506557 L0.295767241,110.820572 L0.301813587,110.810018 L1.74904586,108.289214 L30.7986677,57.7092481 L30.3645176,58.0446002 L31.9400167,55.3076817 L42.7695392,36.4949046 L64.690268,-1.34465526 L64.8060749,-1.09919406 Z M127.900922,110.745487 L92.4019589,49.0671558 L85.9977769,37.9401475 L64.6890647,1.15109078 L43.8520112,37.1200058 L34.5988456,53.1943789 L35.0200448,52.8690305 L33.4513294,55.6004111 L2.83304251,108.91167 L1.77408984,110.756164 L63.9404478,129.129006 L64.6855228,129.348475 L127.900922,110.745487 Z",
    opacity: 0.2,
    transform: "translate(1 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVestaPropertyPattern01TealBg);
export default __webpack_public_path__ + "static/media/vesta-property-pattern-01-teal-bg.45f95a6f667267a9d4654269feba9bc8.svg";
export { ForwardRef as ReactComponent };